import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class FlowerCrown extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="61.80107" cy="45.55338" />
				<path fill="#75C69F" d="M34.61867,15.07672c-0.76818,2.78787-0.95874,5.55765-0.85768,8.06981
					c-0.88042-1.20376-1.88113-2.38256-3.04504-3.47123c-6.97097-6.52247-16.70555-7.44553-16.70555-7.44553
					s2.49143,8.03803,6.15886,15.99851c-0.77731-0.15698-1.56702-0.29235-2.38212-0.37241C8.28595,26.9233,0,32.11535,0,32.11535
					s8.11592,5.74874,16.66604,9.9954c10.43315,5.18172,14.84013,0.48326,16.61896-3.20483
					c3.45995-0.63268,5.96995-3.05658,5.96995-3.05658s-0.14787-0.89206-0.54062-2.30434
					c4.05603-0.1333,10.76999-2.15966,9.61275-14.40271C47.42897,9.63798,44.97332,0,44.97332,0S37.15487,5.87331,34.61867,15.07672z"
					/>
				<path fill="#75C69F" d="M41.36015,36.75166c0,3.42577-4.77095,7.65168-16.24457,7.65168
					c-4.83965,0-1.28135-4.22591-1.28135-7.65168s3.92331-6.20291,8.76296-6.20291S41.36015,33.32589,41.36015,36.75166z" />
				<g>
					<path fill="#75C69F" d="M83.01997,45.11023c1.63772-2.38332,2.72366-4.93845,3.44976-7.34552
						c0.43831,1.42551,0.99846,2.86676,1.74231,4.27622c4.45443,8.44365,13.35178,12.49965,13.35178,12.49965
						s0.27444-8.41082-0.58782-17.13296c0.68322,0.40257,1.38523,0.78876,2.12932,1.13101
						c8.67369,3.98866,18.20203,1.79208,18.20203,1.79208s-5.78947-8.08693-12.48051-14.89637
						c-8.1647-8.30893-13.86597-5.31017-16.75317-2.40668c-3.47659-0.5337-6.6413,0.93601-6.6413,0.93601
						s-0.15201,0.89136-0.24274,2.35442c-3.87657-1.20056-10.88403-1.48145-13.79455,10.46679
						c-2.25967,9.27537-3.09119,19.18644-3.09119,19.18644S77.61326,52.97805,83.01997,45.11023z" />
					<path fill="#75C69F" d="M105.82243,22.86361c2.76254,3.0715-11.40704,11.41925-17.24308,11.41925
						c-5.83604,0-8.56549-3.34889-8.56549-7.47996s4.89334-6.11325,10.56709-7.47996
						C94.80563,18.30527,102.86975,19.5807,105.82243,22.86361z" />
				</g>
				<g>
					<path fill="#836EEA" d="M26.86303,45.75624c-0.23989,0.0549-0.45061,0.11708-0.60677,0.18347
						c-0.93132,0.39466-1.36615,1.46948-0.97157,2.4009c0.39464,0.93145,1.46965,1.36644,2.40092,0.97174
						c0.15715-0.06686,0.35379-0.1834,0.56141-0.31864c-0.07294,0.23669-0.13133,0.45812-0.15211,0.62713
						c-0.12367,1.00372,0.58957,1.91821,1.5936,2.04189c1.00373,0.12406,1.91793-0.58941,2.0419-1.59351
						c0.02051-0.16737,0.01824-0.39403,0.00514-0.63845c0.16928,0.18238,0.33033,0.33542,0.46688,0.43834
						c0.8073,0.60941,1.95572,0.44873,2.56511-0.35905c0.60909-0.80739,0.44833-1.9558-0.35902-2.56525
						c-0.13529-0.10194-0.32485-0.21343-0.544-0.3251c0.23984-0.05494,0.45057-0.11712,0.60672-0.1835
						c0.93127-0.3947,1.36616-1.46949,0.97152-2.40094c-0.39463-0.93145-1.4696-1.3664-2.40092-0.97174
						c-0.15714,0.06685-0.35379,0.1834-0.56141,0.31864c0.07294-0.23669,0.13133-0.45812,0.15211-0.62713
						c0.12367-1.00372-0.58957-1.91821-1.5936-2.04189c-1.00373-0.12406-1.91792,0.58941-2.0419,1.59351
						c-0.02081,0.16776-0.01824,0.39403-0.00514,0.63845c-0.16928-0.18238-0.33033-0.33542-0.46688-0.43834
						c-0.8073-0.60941-1.95568-0.44869-2.56511,0.35905c-0.60909,0.80739-0.44828,1.95584,0.35902,2.56525
						C26.45423,45.53301,26.64383,45.64454,26.86303,45.75624z" />
					<path fill="#836EEA" d="M13.3848,46.763c0.16523-0.04071,0.37825-0.12527,0.60458-0.22607
						c-0.10954,0.22237-0.20182,0.43157-0.24917,0.59533c-0.28045,0.97174,0.27972,1.98724,1.25147,2.26786
						c0.97211,0.28027,1.98729-0.27998,2.26779-1.25168c0.04699-0.1628,0.08369-0.37947,0.10967-0.62435
						c0.13671,0.20465,0.27043,0.3791,0.3879,0.50119c0.70144,0.7287,1.86074,0.75123,2.58971,0.04985
						c0.72892-0.70142,0.75111-1.86059,0.04993-2.58972c-0.11867-0.12303-0.28981-0.26474-0.49119-0.41086
						c0.24456-0.01656,0.46949-0.041,0.63335-0.08155c0.98163-0.24261,1.58077-1.23559,1.33793-2.21763
						s-1.23587-1.58099-2.21781-1.338c-0.16523,0.04072-0.37825,0.12527-0.60458,0.22607
						c0.10954-0.22237,0.20212-0.43195,0.24917-0.59532c0.28075-0.97212-0.27972-1.98724-1.25147-2.26786
						c-0.97181-0.28066-1.98699,0.2796-2.26779,1.25168c-0.04699,0.1628-0.08365,0.37951-0.10932,0.624
						c-0.13705-0.2043-0.27078-0.37875-0.38825-0.50084c-0.70118-0.72912-1.86074-0.75122-2.58971-0.04984
						c-0.72862,0.70103-0.75111,1.86059-0.04993,2.58971c0.11867,0.12303,0.28981,0.26474,0.49119,0.41087
						c-0.24426,0.01617-0.46949,0.041-0.63335,0.08155C11.5233,43.45,10.92416,44.44297,11.167,45.42501
						C11.41013,46.40666,12.40287,47.006,13.3848,46.763z" />
					<path fill="#836EEA" d="M24.50181,37.5037c0.09869-0.13729,0.20607-0.32912,0.31282-0.55119
						c0.06034,0.23856,0.12761,0.44784,0.19707,0.60245c0.41587,0.92202,1.50055,1.33233,2.42246,0.91669
						c0.92221-0.41602,1.33262-1.50062,0.91676-2.42264c-0.07018-0.15517-0.19131-0.34952-0.33119-0.55417
						c0.23827,0.06775,0.46101,0.12089,0.63048,0.13801c1.00652,0.10085,1.90408-0.63305,2.00509-1.6396
						c0.10097-1.00658-0.63331-1.90405-1.63953-2.00528c-0.16812-0.01668-0.39409-0.00915-0.63844,0.00942
						c0.17836-0.17295,0.32775-0.33756,0.4276-0.47642c0.59061-0.82121,0.40379-1.96581-0.41741-2.55633
						c-0.82125-0.59056-1.96564-0.40381-2.55629,0.41736c-0.099,0.13767-0.20638,0.32951-0.31282,0.55119
						c-0.06034-0.23857-0.12761-0.44784-0.19707-0.60245c-0.41587-0.92201-1.50055-1.33233-2.42276-0.91631
						c-0.92191,0.41564-1.33232,1.50024-0.91646,2.42226c0.06988,0.15556,0.19136,0.34955,0.33124,0.5542
						c-0.23832-0.06779-0.46106-0.12093-0.63053-0.13804c-1.00653-0.10085-1.90438,0.63344-2.0051,1.6396
						c-0.10097,1.00658,0.63301,1.90443,1.63954,2.00528c0.16811,0.01667,0.39413,0.00919,0.63849-0.00939
						c-0.17862,0.17338-0.32805,0.33795-0.4276,0.47642c-0.59066,0.82117-0.40384,1.96577,0.41736,2.55629
						C22.76647,38.512,23.91116,38.32486,24.50181,37.5037z" />
				</g>
				<g>
					<polygon fill="#75C69F" points="98.53794,37.54509 60.36802,37.43456 60.83744,21.32865 98.88755,26.55077 			" />
				</g>
				<g>
					<g>
						<path fill="#FC5959" d="M53.26588,16.18153l0.00001-0.00001c3.80442-3.74759,10.17951-0.42141,9.28202,4.84286l0,0.00002
							h0.00002c5.32326-0.42539,8.06884,6.22045,3.99751,9.67622l-0.00002,0.00001l0.00002,0.00001
							c4.35129,3.09586,2.18266,9.95169-3.15748,9.98196h-0.00002l0,0.00002c1.3433,5.16852-4.72481,9.02642-8.83505,5.61703
							l-0.00002-0.00001l-0.00001,0.00002c-2.29323,4.82277-9.42148,3.87759-10.3786-1.37617v-0.00002l-0.00002,0.00001
							c-4.85674,2.22039-9.70974-3.08561-7.06589-7.72544l0.00001-0.00002l-0.00002,0
							c-5.14772-1.42093-5.4547-8.60501-0.44697-10.4599l0.00002-0.00001l-0.00001-0.00001
							c-3.03003-4.39738,1.35265-10.09804,6.3811-8.30005l0.00002,0.00001l0-0.00002
							c0.50545-5.31625,7.52708-6.86608,10.22337-2.25652L53.26588,16.18153z" />
					</g>
					<g>
						<circle fill="#FFEAAE" cx="51.20458" cy="31.72724" r="5.7076" />
					</g>
				</g>
				<g>
					<g>
						<path fill="#FFFFFF" d="M87.24824,10.52279c-0.76722,2.97522-5.51828,12.62603-6.68536,12.32507
							s-0.65871-11.04583,0.10851-14.02104c0.76723-2.97522,2.68226-4.31254,4.49841-3.84421
							C86.98594,5.45093,88.01546,7.54757,87.24824,10.52279z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M76.1131,9.25624c1.32471,2.77231,3.88861,13.21918,2.80112,13.73882
							c-1.08749,0.51964-7.60472-8.03819-8.92943-10.81049s-0.71732-5.02772,0.97497-5.83635S74.78839,6.48393,76.1131,9.25624z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M66.76897,15.44353c2.79679,1.27221,11.47597,7.62693,10.97692,8.72402
							c-0.49905,1.0971-10.9924-1.26939-13.78919-2.54159c-2.79679-1.27221-3.78125-3.39037-3.00467-5.0976
							S63.97218,14.17133,66.76897,15.44353z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M63.58806,26.18957c2.96023-0.82318,13.6936-1.53404,14.01651-0.37284
							s-9.23662,6.09337-12.19684,6.91654c-2.96022,0.82318-5.0759-0.16663-5.57838-1.97363
							C59.32685,28.95266,60.62783,27.01275,63.58806,26.18957z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M68.05877,36.46616c1.73853-2.53339,9.50384-9.97722,10.4976-9.29525
							c0.99377,0.68197-3.15891,10.60497-4.89745,13.13836c-1.73853,2.53339-3.99548,3.13508-5.54192,2.07383
							S66.32023,38.99955,68.05877,36.46616z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M78.08919,41.46477c-0.29663-3.0582,0.86713-13.75195,2.06677-13.86831
							c1.19963-0.11636,4.39687,10.15439,4.6935,13.21258c0.29663,3.0582-1.04552,4.96985-2.91232,5.15092
							S78.38583,44.52296,78.08919,41.46477z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M88.98598,38.8465c-2.193-2.15204-8.17532-11.09199-7.33114-11.95223s9.89532,4.95246,12.08832,7.1045
							c2.19301,2.15204,2.39365,4.47917,1.07999,5.81784C93.50949,41.15526,91.17899,40.99854,88.98598,38.8465z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M95.65042,29.83646c-3.06325-0.23892-13.39245-3.24196-13.29873-4.44357
							c0.09373-1.20161,10.76363-2.56679,13.82688-2.32786c3.06324,0.23892,4.71279,1.89264,4.56694,3.76252
							C100.59967,28.69742,98.71366,30.07538,95.65042,29.83646z" />
					</g>
					<g>
						<path fill="#FFFFFF" d="M94.96413,18.65055c-2.50016,1.78599-12.3431,6.12502-13.04369,5.14428
							c-0.70058-0.98073,6.59552-8.885,9.09568-10.67099s4.82677-1.57948,5.91699-0.05332
							C98.02332,14.59668,97.46429,16.86456,94.96413,18.65055z" />
					</g>
					<g>
						<circle fill="#FFEAAE" cx="79.9096" cy="25.19523" r="7.67494" />
					</g>
				</g>
				<g>
					<path fill="#836EEA" d="M105.16225,32.38733c-0.0312-0.2441-0.07249-0.4599-0.12331-0.62179
						c-0.30178-0.96542-1.32898-1.50319-2.29449-1.20149c-0.96555,0.30174-1.50349,1.32911-1.20167,2.29449
						c0.05119,0.16293,0.14796,0.37002,0.26227,0.58986c-0.22843-0.09572-0.44309-0.17546-0.60927-0.21266
						c-0.98684-0.22115-1.96664,0.39934-2.18781,1.38648c-0.22153,0.9868,0.3992,1.96634,1.38639,2.18782
						c0.16456,0.03676,0.39036,0.05665,0.63489,0.06749c-0.19804,0.15065-0.36609,0.29598-0.48185,0.42181
						c-0.68536,0.7439-0.63766,1.90253,0.10671,2.58792c0.74402,0.68506,1.90265,0.63727,2.58806-0.10667
						c0.11467-0.12468,0.24414-0.30244,0.37669-0.50964c0.03123,0.24406,0.07253,0.45985,0.12334,0.62175
						c0.30183,0.96538,1.32898,1.50319,2.29453,1.20145s1.50345-1.32907,1.20166-2.29449
						c-0.05118-0.16293-0.14796-0.37002-0.26227-0.58985c0.22844,0.09572,0.4431,0.17546,0.60927,0.21266
						c0.98684,0.22114,1.96664-0.39934,2.18782-1.38648c0.22153-0.9868-0.3992-1.96634-1.38639-2.18782
						c-0.16492-0.0371-0.39037-0.05665-0.6349-0.06749c0.19804-0.15065,0.36609-0.29598,0.48186-0.42181
						c0.68536-0.7439,0.63761-1.90248-0.10672-2.58792c-0.74402-0.68506-1.90269-0.63722-2.58805,0.10668
						C105.42435,32.00229,105.29484,32.1801,105.16225,32.38733z" />
					<path fill="#836EEA" d="M105.47715,18.87523c0.02438,0.16842,0.08772,0.38868,0.16592,0.62377
						c-0.2106-0.13074-0.40978-0.24302-0.56813-0.30614c-0.93968-0.37405-2.00506,0.08422-2.37927,1.02391
						c-0.37391,0.94007,0.08448,2.00514,1.02412,2.37923c0.15742,0.06267,0.36948,0.12037,0.61064,0.17015
						c-0.21703,0.11606-0.4037,0.2321-0.53668,0.33708c-0.79375,0.62688-0.92944,1.77844-0.30263,2.57244
						c0.62685,0.79396,1.77831,0.9293,2.57245,0.30271c0.13403-0.10608,0.29179-0.26256,0.45689-0.4487
						c-0.00742,0.24501-0.00507,0.47125,0.01928,0.63829c0.14555,1.00064,1.07523,1.69393,2.0763,1.5482
						c1.00106-0.14573,1.69418-1.0755,1.54828-2.07647c-0.02438-0.16842-0.08772-0.38868-0.16592-0.62377
						c0.2106,0.13074,0.41014,0.24336,0.56813,0.30614c0.94004,0.37438,2.00506-0.08422,2.37928-1.02391
						c0.37426-0.93974-0.08413-2.0048-1.02413-2.37923c-0.15742-0.06267-0.36951-0.12032-0.61033-0.16976
						c0.21671-0.11644,0.40339-0.23248,0.53638-0.33746c0.79414-0.62659,0.92943-1.77844,0.30262-2.57245
						c-0.62649-0.79362-1.77831-0.9293-2.57245-0.30271c-0.13403,0.10608-0.29179,0.26256-0.45689,0.4487
						c0.00777-0.24467,0.00507-0.47125-0.01928-0.63829c-0.14555-1.00064-1.07523-1.69393-2.07629-1.5482
						C106.02471,16.94482,105.33125,17.87425,105.47715,18.87523z" />
					<path fill="#836EEA" d="M113.60601,30.8437c0.12698,0.11164,0.30741,0.23724,0.51799,0.36518
						c-0.24332,0.03675-0.45817,0.08324-0.61882,0.13726c-0.95824,0.3238-1.47256,1.3632-1.14899,2.32131
						c0.32393,0.95845,1.36324,1.47286,2.32148,1.14907c0.16129-0.05468,0.36654-0.15625,0.58388-0.27546
						c-0.09071,0.23051-0.16535,0.44699-0.19895,0.61398c-0.1987,0.99186,0.444,1.95682,1.43586,2.15569
						c0.9919,0.19883,1.95681-0.44425,2.15587-1.43577c0.03302-0.16568,0.04761-0.39131,0.05299-0.63631
						c0.1547,0.1944,0.30392,0.35916,0.43237,0.4721c0.75957,0.66801,1.91695,0.59392,2.58488-0.16566
						c0.66797-0.75962,0.59392-1.91678-0.16561-2.58484c-0.12734-0.11197-0.30777-0.23758-0.51799-0.36518
						c0.24332-0.03675,0.45816-0.08324,0.61882-0.13726c0.95824-0.3238,1.47256-1.3632,1.14863-2.32164
						c-0.32358-0.95811-1.36289-1.47253-2.32113-1.14873c-0.16164,0.05434-0.36658,0.15629-0.58392,0.27551
						c0.09075-0.23056,0.1654-0.44704,0.19899-0.61403c0.1987-0.99186-0.44434-1.95716-1.43585-2.15569
						c-0.99191-0.19883-1.95717,0.44392-2.15587,1.43577c-0.03302,0.16568-0.04765,0.39135-0.05304,0.63635
						c-0.1551-0.1947-0.30428-0.3595-0.43237-0.4721c-0.75954-0.66806-1.91692-0.59396-2.58484,0.16561
						C112.77207,29.01814,112.84647,30.17564,113.60601,30.8437z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/FlowerCrown.js